
/* eslint camelcase: 0 */

import { PublicationStorage as Data } from '@/typings/api/Publication'
import { Model, createMessages } from '@/helpers/Model'


export class PublicationStorageModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить хранилище',
    edit: 'Редактировать хранилище',
    view: (data: PublicationStorageModel) => 'Хранилище {name}'
      .replace('{name}', data.name || '...'),
    list: 'Хранилище',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: PublicationStorageModel) => 'Удаление хранилища'
      .replace('{name}', data.name || '...'),
  });
}
